export const changeBackground = (e: any, color: string) => {
  e.target.style.background = color;
};
